"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisitorGuid = getVisitorGuid;
// TODO: Remove this duplicate after MVP - consolidate with src/helpers/getVisitorGuid.ts
// This is duplicated here to avoid bundling dependencies from src/ into the loader package

var utils = require('@ux/util');
function getVisitorGuid() {
  if (typeof document !== 'undefined') {
    var _cookieValue$replace;
    var cookieValue = utils.cookie.get('visitor');
    return (_cookieValue$replace = cookieValue === null || cookieValue === void 0 ? void 0 : cookieValue.replace('vid=', '')) !== null && _cookieValue$replace !== void 0 ? _cookieValue$replace : '';
  }
  return '';
}